import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'app-message-page',
  templateUrl: './message-page.component.html',
  styleUrls: ['./message-page.component.scss']
})
export class MessagePageComponent implements OnInit {

  message = "";
  constructor(public translate: TranslateService, private activatedRoute: ActivatedRoute) { }

  ngOnInit(): void {
    this.activatedRoute
      .queryParams
      .subscribe(params => {
        let passValue = params['passValue'];
        if(passValue==1){
        this.message=this.translate.instant("REGISTRATION_DONE_PAGE");
        }else if(passValue==2){
          this.message=this.translate.instant("APPLICATION_DONE_PAGE");
        }else{
          this.message="Un none Message";
        }
      });
  }

}
